import { create } from 'zustand'

const useEditScreenStore = create((set) => ({
    dataChangeFunction: undefined,
    setDataChangeFunction: (func, existingItems = null) => set(() => ({ 
        dataChangeFunction: (newItem) => {
            set(() => ({ dataChangeFunction: undefined }))
            return existingItems ? func([...existingItems, newItem]) : func(newItem)
        }
    })),
    clearDataChangeFunction: () => set(() => ({ dataChangeFunction: undefined })),
    setEditScreenData: (screenName, id, params) => set((state) => ({ 
        [screenName]: {
            ...state[screenName],
            [id]: {
                ...state[screenName]?.[id],
                ...params
            }
        }
    })),
    removeEditScreenData: (screenName, id) => set((state) => {
        // No-op without allocating state: returning `state` skips the
        // subscriber notify entirely (cancels must not wake unrelated editors).
        if (!state[screenName]?.[id]) return state;
        // Delete rather than assign undefined — draft ids are unbounded, so
        // retained keys would accumulate for the session lifetime.
        const screen = { ...state[screenName] };
        delete screen[id];
        return {
            [screenName]: Object.keys(screen).length ? screen : undefined
        };
    }),
    clearAllEditScreenData: () => set((state) => {
        // Replace with only the store functions — draft keys are deleted
        // outright instead of left behind as undefined tombstones.
        const newState = {}
        for (const [key, value] of Object.entries(state)) {
            if(typeof value == "function"){
                newState[key] = value
            }
        }

        return newState
    }, true)
}))

export { useEditScreenStore }